function precise(num) {
  return Number(num).toFixed(2);
}

module.exports = precise;
